<div class="toast-container">
  @for (toast of toasts; track toast.id) {
    <div class="toast show">
      <span class="toast-message">{{ toast.message }}</span>
      <button type="button" class="toast-close" aria-label="Fechar" (click)="close(toast.id)">
        <i class="fas fa-xmark"></i>
      </button>
    </div>
  }
</div>
